export const isNullOrUndefined = (variable: any): boolean =>
	variable === null || variable === undefined;

export const isEmptyString = (str: string): boolean =>
	str === '' || str === ' ';

export const base64ToString = (value: string): string => {
	var decodedStringAtoB = atob(value);
	return decodedStringAtoB;
};

export const stringToBase64 = (value: string): string => {
	var encodedStringBtoA = btoa(value);
	return encodedStringBtoA;
};

export const randomIntFromInterval = (min:number, max:number) => { // min and max included 
	return Math.floor(Math.random() * (max - min + 1) + min)
}

export const generateGuid = () => {
	return crypto.randomUUID();
}